"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPONENT_TYPES = void 0;
var COMPONENT_TYPES;
(function (COMPONENT_TYPES) {
    COMPONENT_TYPES["FORM_CONTAINER"] = "wysiwyg.viewer.components.FormContainer";
    COMPONENT_TYPES["DYNAMIC_CONTACT_FORM"] = "wysiwyg.viewer.components.DynamicContactForm";
    COMPONENT_TYPES["STATE_BOX"] = "wysiwyg.viewer.components.StateBox";
    COMPONENT_TYPES["FORM_STATE"] = "wysiwyg.viewer.components.StateBoxFormState";
    COMPONENT_TYPES["SITE_BUTTON"] = "wysiwyg.viewer.components.SiteButton";
    COMPONENT_TYPES["LIGHTBOX_CONTAINER"] = "wysiwyg.viewer.components.PopupContainer";
    COMPONENT_TYPES["TEXT_INPUT"] = "wysiwyg.viewer.components.inputs.TextInput";
    COMPONENT_TYPES["TEXT_AREA"] = "wysiwyg.viewer.components.inputs.TextAreaInput";
    COMPONENT_TYPES["TEXT"] = "wysiwyg.viewer.components.WRichText";
    COMPONENT_TYPES["CHECKBOX"] = "wysiwyg.viewer.components.inputs.Checkbox";
    COMPONENT_TYPES["DATE_PICKER"] = "wysiwyg.viewer.components.inputs.DatePicker";
    COMPONENT_TYPES["RADIO_GROUP"] = "wysiwyg.viewer.components.inputs.RadioGroup";
    COMPONENT_TYPES["CHECKBOX_GROUP"] = "wysiwyg.viewer.components.inputs.CheckboxGroup";
    COMPONENT_TYPES["COMBO_BOX_INPUT"] = "wysiwyg.viewer.components.inputs.ComboBoxInput";
    COMPONENT_TYPES["FILE_UPLOADER"] = "wysiwyg.viewer.components.inputs.FileUploader";
    COMPONENT_TYPES["TIME_PICKER"] = "wixui.TimePicker";
    COMPONENT_TYPES["RATINGS_INPUT"] = "wixui.RatingsInput";
    COMPONENT_TYPES["SIGNATURE_INPUT"] = "wixui.SignatureInput";
    COMPONENT_TYPES["RICH_TEXT_BOX"] = "wixui.RichTextBox";
    COMPONENT_TYPES["SELECTION_TAGS_LIST"] = "wixui.SelectionTagsList";
    COMPONENT_TYPES["SLIDER"] = "wixui.Slider";
    COMPONENT_TYPES["TOGGLE"] = "wixui.ToggleSwitch";
    COMPONENT_TYPES["ADDRESS_INPUT"] = "wixui.AddressInput";
    COMPONENT_TYPES["CAPTCHA"] = "wixui.Captcha";
})(COMPONENT_TYPES = exports.COMPONENT_TYPES || (exports.COMPONENT_TYPES = {}));
//# sourceMappingURL=component-types.js.map